import React from 'react';
import { Users, Building2, Briefcase, UserX, Clock, SearchX } from 'lucide-react';

const MarketerPainPoints: React.FC = () => {
  return (
    <>
      {/* WHO THIS IS FOR */}
      <section className="py-20 bg-slate-950 border-b border-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-white">Who is ProGeoData For?</h2>
            <p className="mt-4 text-slate-400">If you sell to licensed pros, you need verified data.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="group p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-sky-500/50 transition-all duration-300">
              <div className="w-12 h-12 rounded-lg bg-indigo-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Users className="w-6 h-6 text-indigo-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Real Estate Marketers</h3>
              <p className="text-slate-400 leading-relaxed">
                Coaches, recruiters, photographers, and trainers who need to reach licensed agents. Filter by brokerage, years licensed, and market area.
              </p>
            </div>

            <div className="group p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-sky-500/50 transition-all duration-300">
              <div className="w-12 h-12 rounded-lg bg-sky-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Building2 className="w-6 h-6 text-sky-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Insurance Recruiters</h3>
              <p className="text-slate-400 leading-relaxed">
                IMOs and lead vendors building agent networks. Verify active licenses and carrier appointments before you pitch your opportunities.
              </p>
            </div>

            <div className="group p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-sky-500/50 transition-all duration-300">
              <div className="w-12 h-12 rounded-lg bg-emerald-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Briefcase className="w-6 h-6 text-emerald-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Agency Owners</h3>
              <p className="text-slate-400 leading-relaxed">
                Marketing agencies serving medical, dental, and legal verticals. Get verified contact data for licensed practitioners in any zip code.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* THE PROBLEM */}
      <section className="py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-bold text-white">Why Your Current Data is Failing You</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 rounded-xl bg-gradient-to-br from-slate-900 to-slate-900 border border-slate-800 relative overflow-hidden">
               <div className="absolute top-0 right-0 p-4 opacity-10">
                 <UserX className="w-24 h-24 text-rose-500" />
               </div>
               <h3 className="text-lg font-bold text-white mb-4 flex items-center">
                 <UserX className="w-5 h-5 text-rose-500 mr-2" /> Stale Data Kills Deals
               </h3>
               <p className="text-slate-400 text-sm leading-relaxed">
                 You're calling numbers that were valid 6 months ago. 30% of contact data decays every year. That's wasted time and burned ad spend.
               </p>
            </div>

            <div className="p-8 rounded-xl bg-gradient-to-br from-slate-900 to-slate-900 border border-slate-800 relative overflow-hidden">
               <div className="absolute top-0 right-0 p-4 opacity-10">
                 <Clock className="w-24 h-24 text-amber-500" />
               </div>
               <h3 className="text-lg font-bold text-white mb-4 flex items-center">
                 <Clock className="w-5 h-5 text-amber-500 mr-2" /> Manual Research is a Time Sink
               </h3>
               <p className="text-slate-400 text-sm leading-relaxed">
                 Your team spends hours on state licensing board websites, Googling phone numbers, and cross-referencing records. That's not selling — that's clerical work.
               </p>
            </div>

            <div className="p-8 rounded-xl bg-gradient-to-br from-slate-900 to-slate-900 border border-slate-800 relative overflow-hidden">
               <div className="absolute top-0 right-0 p-4 opacity-10">
                 <SearchX className="w-24 h-24 text-indigo-500" />
               </div>
               <h3 className="text-lg font-bold text-white mb-4 flex items-center">
                 <SearchX className="w-5 h-5 text-indigo-500 mr-2" /> You Can't Verify Status
               </h3>
               <p className="text-slate-400 text-sm leading-relaxed">
                 Nothing kills credibility faster than pitching someone whose license is suspended. And nothing wastes money faster than marketing to people who left the industry.
               </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MarketerPainPoints;